import LoginAccountSelection from './LoginAccountSelection';
import AccountOutline from '../../assets/svg/header_account_outline.svg';
import HeaderChevronDown from '../../assets/svg/header_chevron_down.svg';
import JDFLogo from '../../assets/svg/HeaderLogo.svg';
import JDFLogoSM from '../../assets/svg/jdf_logo.svg';
import OrgOutline from '../../assets/svg/login_account_org.svg';
import BurgerMenuIcon from '../../assets/svg/menu.svg';
import SwitchAccountOrg from '../../assets/svg/switch_account_org.svg';
import SwitchAccountOrgSelected from '../../assets/svg/switch_account_org_selected.svg';
import SwitchAccountUser from '../../assets/svg/switch_account_user.svg';
import UserRoundPen from '../../assets/svg/user_round_pen.svg';
import UserSelected from '../../assets/svg/userSelected.svg';
import NotificationIcon from '../../component/NotificationIcon/NotificationIcon';
import {useMenuVisibility} from '../../hooks/useMenuVisibility';
import {pushViewAction, setOrganization} from '../../redux/actions/Actions';
import {appStore} from '../../redux/createStore';
import {
  ACCOUNT_SELECTION_SHOWN_KEY,
  MENU_OPTIONS_UNLEASH_KEY,
} from '../../utils/constant';
import {getAllRelationships, getUsername, Navigate} from '../../utils/util';
import BurgerMenu from '../BurgerMenu/BurgerMenu';
import GlobalSearch from '../GlobalSearch/GlobalSearch';
import './header.css';

import {Drawer} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

const getLoginId = (oktaAuth) => {
  const claims = oktaAuth?.tokenManager?.getTokensSync?.()?.idToken?.claims;
  return String(claims?.auth_time ?? claims?.iat ?? 'unknown');
};

const HeaderNav = (props) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [orgList, setOrgList] = React.useState([]);
  const [username, setUsername] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);
  const [isLoginSelectionOpen, setIsLoginSelectionOpen] = React.useState(false);

  const {t} = useTranslation();
  const {flag: sidebarFlag, isItemVisible} = useMenuVisibility(
    MENU_OPTIONS_UNLEASH_KEY
  );

  const elementRef = React.useRef(null);

  const handleClickOutside = (event) => {
    if (elementRef.current && !elementRef.current.contains(event.target)) {
      setIsPopoverOpen(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setIsPopoverOpen(false);
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  React.useEffect(() => {
    if (props.allContracts) {
      setOrgList(getAllRelationships(props.allContracts));
      setLoading(false);
    }
  }, [props.allContracts]);

  React.useEffect(() => {
    if (!props.allContracts) return;
    if (props.org && props.allContracts?.organisation?.[props.org]) {
      setUsername(props.allContracts.organisation[props.org].name);
    } else {
      setUsername(getUsername(props.allContracts));
    }
  }, [loading, props.org]);

  const handleOrgChange = (item) => {
    let newOrg = Object.keys(item)[0];
    setUsername(Object.values(item)[0]);
    appStore.dispatch(setOrganization(newOrg));
    props.onOrgChange(newOrg);
    setIsPopoverOpen(false);
  };

  const handleUserChange = (item) => {
    setUsername(item);
    appStore.dispatch(setOrganization(null));
    props.onOrgChange(item);
    setIsPopoverOpen(false);
  };

  const personalAccount = props.allContracts?.personal;
  const organisations = props.allContracts?.organisation ?? {};
  let selectedOrgId = null;
  if (props.org && organisations[props.org]) {
    selectedOrgId = props.org;
  } else if (!personalAccount?.name) {
    selectedOrgId = Object.keys(organisations)[0] ?? null;
  }

  const accounts = [
    ...(personalAccount?.name
      ? [
          {
            id: 'personal-account',
            name: personalAccount.name,
            activeContractCount: personalAccount.accounts?.length ?? 0,
            isPersonal: true,
            isSelected: !selectedOrgId,
          },
        ]
      : []),
    ...orgList.map((item) => {
      const id = Object.keys(item)[0];
      return {
        id,
        name: Object.values(item)[0],
        activeContractCount: organisations[id]?.accounts?.length ?? 0,
        item,
        isPersonal: false,
        isSelected: selectedOrgId === id,
      };
    }),
  ];
  const selectedAccount = accounts.find((account) => account.isSelected);

  const hasContracts =
    !props.contractNumber?.contractCounts <= 0 ||
    !props.contractNumber?.pastContractsCounts <= 0;
  const canSwitchAccount =
    !loading && orgList.length > 0 && hasContracts && accounts.length > 1;
  const showManageAccount = !sidebarFlag || isItemVisible('myAccount');
  const showAccountSelector = canSwitchAccount || showManageAccount;

  const autoOpenedRef = React.useRef(false);
  React.useEffect(() => {
    if (!canSwitchAccount || autoOpenedRef.current) return;
    autoOpenedRef.current = true;
    const loginId = getLoginId(props.oktaAuth);
    if (localStorage.getItem(ACCOUNT_SELECTION_SHOWN_KEY) !== loginId) {
      localStorage.setItem(ACCOUNT_SELECTION_SHOWN_KEY, loginId);
      setIsLoginSelectionOpen(true);
    }
  }, [canSwitchAccount]);

  const handleAccountSelect = (account) => {
    if (account.isPersonal) {
      handleUserChange(account.name);
    } else {
      handleOrgChange(account.item);
    }
  };

  const handleLoginAccountContinue = (account) => {
    if (!account.isSelected) {
      handleAccountSelect(account);
    }
    setIsLoginSelectionOpen(false);
  };

  const renderAccountAvatar = (account) => {
    if (!account.isPersonal) {
      return (
        <span
          className={
            account.isSelected
              ? 'account-switcher-avatar account-switcher-avatar-org account-switcher-avatar-selected'
              : 'account-switcher-avatar account-switcher-avatar-org'
          }
        >
          <img
            src={
              account.isSelected ? SwitchAccountOrgSelected : SwitchAccountOrg
            }
            alt=""
          />
        </span>
      );
    }
    return account.isSelected ? (
      <span className="account-switcher-avatar account-switcher-avatar-selected">
        <img src={SwitchAccountUser} alt="" />
      </span>
    ) : (
      <span className="account-switcher-avatar account-switcher-avatar-muted">
        <img src={UserSelected} alt="" />
      </span>
    );
  };

  return (
    <>
      {isLoginSelectionOpen && selectedAccount && (
        <LoginAccountSelection
          accounts={accounts}
          selectedAccountId={selectedAccount.id}
          customerId={props.customerId}
          onContinue={handleLoginAccountContinue}
        />
      )}
      <header id="CustomHeader">
        <div
          className="jdf-logo-lg"
          onClick={() => {
            Navigate('home');
          }}
        >
          <img src={JDFLogo} alt="JDF Logo" /> <span>MyFinancial</span>
        </div>
        <div
          className="jdf-logo-sm"
          onClick={() => {
            Navigate('home');
          }}
        >
          <img src={JDFLogoSM} alt="JDF Logo Small" />
        </div>

        <div className="header-content-main">
          <div className="header-content">
            <GlobalSearch />
            {!sidebarFlag || isItemVisible('notification') ? (
              <NotificationIcon
                navigate={() => Navigate('notification')}
                customerId={props.customerId}
              />
            ) : null}
            {showAccountSelector ? (
              <div className="account-switcher-anchor" ref={elementRef}>
                <button
                  type="button"
                  id="popup-btn-header"
                  data-testid="popup-btn-header"
                  className="account-selector-btn"
                  aria-expanded={isPopoverOpen}
                  aria-haspopup="menu"
                  aria-label={username ?? t('MY_ACCOUNT')}
                  onClick={() => setIsPopoverOpen(!isPopoverOpen)}
                >
                  <img
                    src={selectedOrgId ? OrgOutline : AccountOutline}
                    alt=""
                    data-testid={
                      selectedOrgId
                        ? 'account-selector-org-icon'
                        : 'account-selector-personal-icon'
                    }
                    className={
                      selectedOrgId
                        ? 'account-selector-icon account-selector-icon-org'
                        : 'account-selector-icon'
                    }
                  />
                  {username && (
                    <span className="account-selector-text">
                      <span className="account-selector-name" data-sl="mask">
                        {username}
                      </span>
                    </span>
                  )}
                  <img
                    src={HeaderChevronDown}
                    alt=""
                    data-testid="account-selector-chevron"
                    className={
                      isPopoverOpen
                        ? 'account-selector-chevron account-selector-chevron-open'
                        : 'account-selector-chevron'
                    }
                  />
                </button>
                {isPopoverOpen && (
                  <div
                    className="account-switcher-popover"
                    role="menu"
                    aria-label={t('SWITCH_ACCOUNT')}
                  >
                    {canSwitchAccount && selectedAccount && (
                      <>
                        <div className="account-switcher-title">
                          {t('SWITCH_ACCOUNT')}
                        </div>
                        <div className="account-switcher-list">
                          {accounts.map((account) => (
                            <button
                              type="button"
                              className={
                                account.isSelected
                                  ? 'account-switcher-option account-switcher-option-current'
                                  : 'account-switcher-option'
                              }
                              id={
                                account.isPersonal
                                  ? 'header-list-dropdown-personal'
                                  : 'header-list-dropdown-org'
                              }
                              key={account.id}
                              role="menuitem"
                              aria-current={
                                account.isSelected ? 'true' : undefined
                              }
                              onClick={() =>
                                account.isSelected
                                  ? setIsPopoverOpen(false)
                                  : handleAccountSelect(account)
                              }
                            >
                              {renderAccountAvatar(account)}
                              <span
                                className="account-switcher-name"
                                data-sl="mask"
                              >
                                {account.name}
                              </span>
                            </button>
                          ))}
                        </div>
                      </>
                    )}
                    {showManageAccount && (
                      <>
                        {canSwitchAccount && (
                          <div className="account-switcher-divider" />
                        )}
                        <button
                          type="button"
                          className="account-switcher-manage"
                          data-testid="profile-icon-header"
                          role="menuitem"
                          onClick={() => {
                            setIsPopoverOpen(false);
                            appStore.dispatch(pushViewAction('myAccount'));
                          }}
                        >
                          <img src={UserRoundPen} alt="" />
                          <span>{t('MANAGE_ACCOUNT')}</span>
                        </button>
                      </>
                    )}
                  </div>
                )}
              </div>
            ) : null}
          </div>
          <div
            className="burger-menu"
            id="burger-menu"
            onClick={() => setIsMenuOpen(true)}
          >
            <img src={BurgerMenuIcon} alt="Menu" />
          </div>
        </div>
      </header>

      <Drawer
        position={'right'}
        open={isMenuOpen}
        id="header-drawer"
        onClose={() => setIsMenuOpen(false)}
      >
        <div className="burger-menu-content">
          <BurgerMenu
            setIsMenuOpen={setIsMenuOpen}
            selectedMenu={props.selectedMenu}
            setVisible={props.setVisible}
            contractNumberError={props.contractNumberError}
          />
        </div>
      </Drawer>
    </>
  );
};

export const mapStateToProps = (state) => {
  return {
    allContracts: state.appStates.allContracts,
    org: state.appStates.selectedOrg,
    contractNumber: state.appStates.contractNumbers,
    contractNumberError: state.appStates.contractNumberError,
  };
};
export default connect(mapStateToProps)(HeaderNav);
